/**--internal-*/
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

/**--relative-*/
import SchoolLevelSettings from "../../routes/SchoolLevelSettings/index";
import CourseLevelSettings from "../../routes/CourseLevelSettings/index";

export default store => ({
  path: "course-class-settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "courseAndClassModuleSettings" */ "../../components/CourseAndClassModuleSettings"
      ),
      import(
        /* webpackChunkName: "courseAndClassModuleSettings" */ "../../modules/CourseAndClassModuleSettingsModule"
      ),
    ])
      .then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "courseAndClassModuleSettings",
          reducer,
        });
        return component;
      })
      .catch(err => {
        throw err;
      })
  ),
  childRoutes: [SchoolLevelSettings(store), CourseLevelSettings(store)],
});
